import Countdown from 'react-countdown'
import { StatBar } from '../stats/StatBar'
import { Histogram } from '../stats/Histogram'
import { GameStats } from '../../lib/localStorage'
import { shareStatus } from '../../lib/share'
import { formatGrammaticalClass, tomorrow } from '../../lib/words'
import { BaseModal } from './BaseModal'
import { ShareIcon } from '@heroicons/react/outline'

import {
  STATISTICS_TITLE,
  GUESS_DISTRIBUTION_TEXT,
  NEW_WORD_TEXT,
  SHARE_TEXT,
} from '../../constants/strings'
import { DefinitionData } from '../../api/types'
import parse from 'html-react-parser'

type Props = {
  isOpen: boolean
  handleClose: () => void
  solution: string
  guesses: string[]
  gameStats: GameStats
  isGameLost: boolean
  isGameWon: boolean
  handleShareToClipboard: () => void
  isHardMode: boolean
  isDarkMode: boolean
  isHighContrastMode: boolean
  numberOfGuessesMade: number
  solutionData?: DefinitionData
}

export const StatsModal = ({
  isOpen,
  handleClose,
  solution,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  handleShareToClipboard,
  isHardMode,
  isDarkMode,
  isHighContrastMode,
  numberOfGuessesMade,
  solutionData,
}: Props) => {
  if (gameStats.totalGames <= 0) {
    return (
      <BaseModal
        title={STATISTICS_TITLE}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <StatBar gameStats={gameStats} />
      </BaseModal>
    )
  }
  return (
    <BaseModal
      title={STATISTICS_TITLE}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <StatBar gameStats={gameStats} />
      <h4 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
        {GUESS_DISTRIBUTION_TEXT}
      </h4>
      <Histogram
        gameStats={gameStats}
        isGameWon={isGameWon}
        numberOfGuessesMade={numberOfGuessesMade}
      />
      {(isGameLost || isGameWon) && (
        <div className="py-2 columns-2 dark:text-white">
          <div className="text-center ">
            <h5 className="py-0 text-sm my-0">{NEW_WORD_TEXT}</h5>
            <Countdown
              className="text-3xl font-medium text-gray-900 dark:text-gray-100"
              date={tomorrow}
              daysInHours={true}
            />
          </div>
          <button
            type="button"
            className="btn-cataletras-share btn-share-modal mt-1 w-full rounded-md border border-transparent shadow-sm px-4 py-3 bg-[#1C6FA7] hover:bg-[#09588D] text-base f-title font-bold text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1C6FA7] sm:text-sm"
            onClick={() => {
              shareStatus(
                solution,
                guesses,
                isGameLost,
                isHardMode,
                isDarkMode,
                isHighContrastMode,
                handleShareToClipboard,
                gameStats
              )
            }}
          >
            {SHARE_TEXT}
            <ShareIcon
                className="inline h-6 w-6 ml-1 cursor-pointer dark:stroke-white align-middle"
              />
          </button>
        </div>
      )}
      {(isGameLost || isGameWon) && solutionData && (
        <div className="mt-2 pt-3 px-2 border-slate-200 border-solid border-t-2 text-left">
          <a
            href={`/${solutionData.url}/` ?? '#'}
            className="wrdl-link f-title font-bold text-2xl text-[#063859]"
          >
            {solution}
          </a>
          <p className="text-[#666] text-sm">
            {formatGrammaticalClass(solutionData.definicao[0]?.classificacao)}
          </p>
          <p className="text-[#404040] py-0 pl-[8px]">
            {parse(solutionData.definicao[0]?.acepcoes[0])}
          </p>
        </div>
      )}
    </BaseModal>
  )
}
